import constants from "../../constants";
import vbOutgoingDocUserViewService from "../../services/vbOutgoingDocUserViewService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import utils from "../../services/utils";
import h from "../../services/h";
import vbDocUserService from "../../services/vbDocUserService";

export default {
  mixins: [vbAttachmentTokenMixin],
  filters: {buildAttachmentURL},

  props: ["sort", "sortList", "order", "advanceSearchForm"],
  data() {
    return {

      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      outgoingDocs: [],
      filteredTuChoiDoc: [],
      outgoingDocsCount: null,
      page: 0,
      size: 10,
      perfectScrollbarSetting: {
        maxScrollbarLength: 250
      }
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
  },

  methods: {
    deleteDoc(item) {
      this.$emit("deleteDoc", item);
    },

    doSort(sort) {
      let order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.$emit("doSort", {order: order, sort: sort});
    },

    // countList: function () {
    //   vbOutgoingDocUserViewService
    //     .count(this.usingAdvanceSearch, this.keyword, this.status, this.advanceSearchForm, this.docStatus, this.fromCreateTime, this.toCreateTime)
    //     .then(response => {
    //       this.outgoingDocsCount = response.data;
    //     });
    // },

    doSearch() {
      console.log('it is searching the list')
      this.outgoingDocs = [];
      this.filteredTuChoiDoc = [];
      this.page = 0;
      // this.countList();
      this.$refs.infiniteLoading.stateChanger.reset();
    },

    async list() {
      let pageable;
      if (this.sortList && this.sortList.length > 0) {
        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: this.page,
          size: this.size,
          sort: sort
        };
      } else {
        pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
      }

      let docStatus = !this.advanceSearchForm.docStatus
        ? [
          constants.OUTGOING_DOC_STATUS.TAOMOI,
          constants.OUTGOING_DOC_STATUS.DANGXULI,
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
          constants.OUTGOING_DOC_STATUS.TU_CHOI,
          constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH
        ]
        : [this.advanceSearchForm.docStatus];
      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP;
          break;
        default:
          relationType = null;
      }
      let status;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          status = constants.DOC_USER_STATUS.CHO_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          status = constants.DOC_USER_STATUS.DA_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        default:
          status = -1;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });

      let items = [];

      await vbOutgoingDocUserViewService
        .findAll2(advanceSearchForm, pageable)
        .then(response => {
          items = response.data;
        });
      await vbDocUserService.getAllVbIsStarByUserDeptRole(this.userDeptRoleId)
        .then(response => {
          const vbDocIdsIsStarMap = response.data;

          for(let i = 0; i < items.length; i++) {
            items[i].isStar = 0;
            for(let key in vbDocIdsIsStarMap) {
              if (key === items[i].docId) {
                items[i].isStar = vbDocIdsIsStarMap[key]
              }
            }
          }
          this.outgoingDocs.push(...items);
          console.log("this.outgoingDocs size: ", this.outgoingDocs.length)
          console.log("this.filteredTuChoiDoc size: ", this.filteredTuChoiDoc.length)
          for (const doc of items) {
            let userId = this.$store.getters.user.id;
                if (userId === doc.creatorId){
                  this.filteredTuChoiDoc.push(doc)
                }
                else{
                  if (doc.status !== constants.INCOMING_DOC_STATUS.TU_CHOI) {
                    this.filteredTuChoiDoc.push(doc)
                  }
                }
             }
        })
      return items;
    },

    infiniteHandler($state) {
      // console.log(' infiniteHandler($state)', $state)
      this.list().then(items => {
        //console.log(items)
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPriority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    getSecurityClass(id) {
      return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    getStatusLabel(status) {
      switch (status) {
        case constants.OUTGOING_DOC_STATUS.TAOMOI:
          return "Tạo mới";
        case constants.OUTGOING_DOC_STATUS.DABANHANH:
          return "Đã ban hành";
        case constants.OUTGOING_DOC_STATUS.DANGXULI:
          return "Đang trình ký";
        case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
          return "Chờ ban hành";
        case constants.OUTGOING_DOC_STATUS.TU_CHOI:
          return "Đã từ chối";
        case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
          return "Từ chối ban hành";
        default:
          return status;
      }
    },

    isSeen(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "is-seen";
      } else return "";
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    },

    viewDetail(item) {
      //console.log(item)
      item.isSeen = 1;
      this.$emit("viewDetail", item);
    },
    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.docId})}`,
      );
    },
    exportSearchResult(fileType,name) {
      let pageable;
      if (this.sortList && this.sortList.length > 0) {
        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: 0,
          size: 1000,
          sort: sort
        };
      } else {
        pageable = {
          page: 0,
          size: 1000,
          sort: [this.sort, this.order].join(",")
        };
      }

      let docStatus = !this.advanceSearchForm.docStatus
        ? [
          constants.OUTGOING_DOC_STATUS.TAOMOI,
          constants.OUTGOING_DOC_STATUS.DANGXULI,
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
          constants.OUTGOING_DOC_STATUS.TU_CHOI,
          constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH
        ]
        : [this.advanceSearchForm.docStatus];
      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP;
          break;
        default:
          relationType = null;
      }
      let status;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          status = constants.DOC_USER_STATUS.CHO_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          status = constants.DOC_USER_STATUS.DA_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        default:
          status = -1;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });
      let params = utils.merge(advanceSearchForm, pageable)
      params.userId = this.$store.getters.userDeptRole.userId;
      params.deptId = this.$store.getters.userDeptRole.deptId;
      params.roleId = this.$store.getters.userDeptRole.roleId;
      params.positionId = this.$store.getters.userDeptRole.positionId;
      params.fileType = fileType
      params.name = name
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_DU_THAO;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
      );

    },

    changeStar(item) {
      const isStar = item.isStar === 1 ? 0 : 1

      vbDocUserService.setStar({
        vbDocId: item.id,
        userDeptRoleId: this.userDeptRoleId,
        isStar: isStar
      })
        .then(() => {
          item.isStar = isStar

          // Nếu đang filter theo văn bản có dấu sao thì sẽ reload trang nếu có thay đổi dấu sao của 1 văn bản
          if(this.advanceSearchForm.isStar) {
            this.doSearch();
          }
        })
        .catch(() => {
          console.log('Không thể đánh dấu sao cho văn bản!')
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-out/mainContentMixin.js